import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useContext, useState } from "react";
import CollapsedIcon from "@mui/icons-material/ExpandLess";
import ExpandIcon from "@mui/icons-material/ExpandMore";
import IconButton from "@mui/material/IconButton";
// import { CollapsedIcon, ExpandIcon } from "./ExpandIcon";
import { ViewerDepthContext, ViewerExpandDepthContext } from "./ViewerContext";
import { Code, color } from "./styles";
function StringifyViewer(props) {
    return _jsx(Code, { sx: { color: color.error }, children: JSON.stringify(props.value) });
}
function TextViewer(props) {
    return (_jsxs(Code, { sx: { color: color.string }, children: [_jsx("small", { children: "string" }), " ", _jsx("span", { children: JSON.stringify(props.value) })] }));
}
function SymbolViewer(props) {
    return (_jsxs(Code, { sx: { color: color.symbol }, children: [_jsx("small", { children: "symbol" }), " ", _jsx("span", { children: props.value.toString() })] }));
}
function BooleanViewer(props) {
    return (_jsxs(Code, { sx: { color: color.boolean }, children: [_jsx("small", { children: "boolean" }), " ", _jsx("span", { children: JSON.stringify(props.value) })] }));
}
function NumberViewer(props) {
    return (_jsxs(Code, { sx: { color: color.number }, children: [_jsx("small", { children: "number" }), " ", props.value] }));
}
function BigIntViewer(props) {
    return (_jsxs(Code, { sx: { color: color.number }, children: [_jsx("small", { children: "number" }), " ", props.value.toString()] }));
}
function UndefinedViewer(_props) {
    return _jsx(Code, { sx: { color: color.undefined }, children: "undefined" });
}
function NullViewer(_props) {
    return _jsx(Code, { sx: { color: color.null }, children: "null" });
}
function FunctionViewer(_props) {
    return _jsx(Code, { sx: { color: color.null }, children: "Function" });
}
function NameViewer(props) {
    return _jsx(Code, { sx: { color: color.key }, children: JSON.stringify(props.name) });
}
function IndexViewer(props) {
    return _jsx(Code, { style: { color: color.index }, children: props.index });
}
function isPrimitive(value) {
    return typeof value !== "object" && value !== null;
}
function ObjectViewer(props) {
    const depth = useContext(ViewerDepthContext);
    const expandDepth = useContext(ViewerExpandDepthContext);
    const [expanded, setExpand] = useState(depth <= expandDepth);
    const entries = Object.entries(props.value);
    const items = !expanded ? (_jsx("span", { children: "..." })) : (_jsx("div", { children: entries.map(([key, value]) => (_jsx("div", { style: {
                display: isPrimitive(value) ? "flex" : "block",
                paddingLeft: "1em",
            }, children: _jsxs(ViewerDepthContext.Provider, { value: depth + 1, children: [_jsx(NameViewer, { name: key }), _jsx("span", { style: { paddingRight: "0.25em" }, children: ":" }), _jsx(UnknownViewer, { name: key, value: value })] }) }, key))) }));
    return (_jsxs(Fragment, { children: [_jsx(IconButton, { onClick: () => setExpand(!expanded), type: "button", size: "small", color: "inherit", sx: { p: 0, mx: 0.5 }, children: expanded ? _jsx(ExpandIcon, {}) : _jsx(CollapsedIcon, {}) }), _jsx("span", { children: "{" }), items, _jsx("span", { children: "}" })] }));
}
function ArrayViewer(props) {
    const depth = useContext(ViewerDepthContext);
    const expandDepth = useContext(ViewerExpandDepthContext);
    const [expanded, setExpand] = useState(depth <= expandDepth);
    const items = !expanded ? (_jsx("span", { children: "..." })) : (_jsx("div", { children: props.value.map((value, index) => (_jsx("div", { style: {
                display: isPrimitive(value) ? "flex" : "block",
                paddingLeft: "1em",
            }, children: _jsxs(ViewerDepthContext.Provider, { value: depth + 1, children: [_jsx(IndexViewer, { index: index }), _jsx("span", { style: { paddingRight: "0.25em" }, children: ":" }), _jsx(UnknownViewer, { name: index.toString(), value: value })] }) }, index))) }));
    return (_jsxs(Fragment, { children: [_jsx(IconButton, { onClick: () => setExpand(!expanded), type: "button", size: "small", color: "inherit", sx: { p: 0, mx: 0.5 }, children: expanded ? _jsx(ExpandIcon, {}) : _jsx(CollapsedIcon, {}) }), _jsx("span", { children: "[" }), items, _jsx("span", { children: "]" })] }));
}
function ObjectViewerSwitch(props) {
    if (Array.isArray(props.value)) {
        return _jsx(ArrayViewer, { value: props.value });
    }
    if (props.value == null) {
        return _jsx(NullViewer, { name: props.name, value: props.value });
    }
    return _jsx(ObjectViewer, { name: props.name, value: props.value });
}
export function UnknownViewer(props) {
    var _a;
    const Components = {
        symbol: SymbolViewer,
        string: TextViewer,
        number: NumberViewer,
        boolean: BooleanViewer,
        object: ObjectViewerSwitch,
        undefined: UndefinedViewer,
        bigint: BigIntViewer,
        function: FunctionViewer,
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const Component = (_a = Components[typeof props.value]) !== null && _a !== void 0 ? _a : StringifyViewer;
    return _jsx(Component, { name: props.name, value: props.value });
}
//# sourceMappingURL=ObjectViewer.js.map